import { Button, CharField, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import type { FiltersBase } from "../../types"
import { TableUtenti } from "./TableUtenti"
import { useNavigate } from "react-router-dom"
import { useUtentiList } from "../../hooks/utenti"
import { useQsFilters } from "../../hooks/filters"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "full_name",
  } as FiltersBase)

export default function Utenti() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data, refetch } = useUtentiList({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
  })

  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Utenti" }])

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>Utenti</H1>
          <Button
            size="md"
            className="text-white"
            title="Aggiungi"
            leadingIcon="add"
            onClick={() => {
              navigate("/utenti/utenti/new")
            }}
          />
        </Flex>
        <Flex className="mb-3">
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value , page: 1 })
            }}
          />
        </Flex>
        <TableUtenti
          utenti={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
          refetch={refetch}
        />
      </Flex>
    </Layout>
  )
}
